/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.idealpos.financialreport')
.controller('QaIdealposFinancialreportCtrl', ["$filter", "FinancialReport", "reporttime", "$q", "$scope", "$stateParams", "title", function($filter, FinancialReport, reporttime, $q, $scope, $stateParams, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month', 'year', 'yesterday', 'custom']);
  reporttime.defaultType = 'day';

  title.set('Financial Report');

  $scope.startTime = reporttime.start();
  $scope.endTime = reporttime.end();

  var loadingPromises = {
    report: FinancialReport.getFinancialReport($scope.startTime, $scope.endTime)
  };

  $scope.loading = $q.all(loadingPromises);
  $scope.loading.then(function(result) {
    $scope.report = result.report;
  });

  $scope.totalTenderAmt = function() {
    var tot = 0;
    angular.forEach($scope.report.tenders, function(item) {
      tot += item.amount;
    });
    tot += $scope.report.cashOutAmt;
  };

  $scope.totalTenderDrawer = function() {
    var tot = 0;
    angular.forEach($scope.report.tenders, function(item) {
      tot += item.drawer;
    });
  };
}]);
